const blankButtonStyle = {
    border: "none",
    background: "none",
    cursor: "pointer",
}

export default blankButtonStyle